import React from 'react';

import { LanguageContextProvider } from 'widget-shared-components-library';

import { ParamsProvider } from './contexts/ParamsContext';

import { Widget, WidgetParams } from './widgets';


import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './App.scss';

const App = ({ initialParams, content, children }) => {
  const { locale, ...params } = initialParams ?? {};
  return (
    <LanguageContextProvider language={locale}>
      <ParamsProvider params={WidgetParams(content, params)}>
          <Widget content={content} >
              {children}
          </Widget>
      </ParamsProvider>
    </LanguageContextProvider>
  );
};

export default App;
